(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.cpdp');
    sections.forEach(initSection);

    function initSection(root) {
      const sectionId = root.dataset.sectionId;
      const variantData = JSON.parse(
        document.querySelector(`[data-product-json="${sectionId}"]`)?.textContent || '[]'
      );

      /* ---------- GALLERY ---------- */
      const slides = root.querySelectorAll('[data-slide-index]');
      const thumbs = root.querySelectorAll('[data-thumb-index]');
      const thumbTrack = root.querySelector('[data-thumb-track]');
      let currentSlide = 0;

      function goToSlide(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
        currentSlide = idx;
        // Scroll active thumb into view
        if (thumbTrack && thumbs[idx]) {
          const thumb = thumbs[idx];
          const trackLeft = thumbTrack.scrollLeft;
          const trackWidth = thumbTrack.offsetWidth;
          const thumbLeft = thumb.offsetLeft;
          const thumbWidth = thumb.offsetWidth;
          if (thumbLeft < trackLeft) {
            thumbTrack.scrollTo({ left: thumbLeft, behavior: 'smooth' });
          } else if (thumbLeft + thumbWidth > trackLeft + trackWidth) {
            thumbTrack.scrollTo({ left: thumbLeft + thumbWidth - trackWidth, behavior: 'smooth' });
          }
        }
      }
      thumbs.forEach(t => t.addEventListener('click', () => goToSlide(parseInt(t.dataset.thumbIndex, 10))));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goToSlide(currentSlide - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => goToSlide(currentSlide + 1));

      /* ---------- THUMBNAIL STRIP ARROWS ---------- */
      const thumbPrev = root.querySelector('[data-thumb-prev]');
      const thumbNext = root.querySelector('[data-thumb-next]');
      if (thumbTrack) {
        thumbPrev?.addEventListener('click', () => {
          const thumbWidth = thumbTrack.querySelector('.cpdp__thumb')?.offsetWidth || 80;
          thumbTrack.scrollBy({ left: -(thumbWidth + 8), behavior: 'smooth' });
        });
        thumbNext?.addEventListener('click', () => {
          const thumbWidth = thumbTrack.querySelector('.cpdp__thumb')?.offsetWidth || 80;
          thumbTrack.scrollBy({ left: thumbWidth + 8, behavior: 'smooth' });
        });
      }

      /* ---------- LIGHTBOX ---------- */
      const lightbox = document.getElementById('cpdp-lightbox-{{ section.id }}');
      const lightboxImg = lightbox?.querySelector('[data-lightbox-img]');
      const lightboxCounter = lightbox?.querySelector('[data-lightbox-counter]');
      let lightboxSlides = [];
      let lightboxCurrent = 0;

      function buildLightboxSlides() {
        lightboxSlides = [];
        slides.forEach((slide) => {
          const src = slide.dataset.zoomSrc || slide.querySelector('img')?.src;
          const alt = slide.querySelector('img')?.alt || '';
          if (src) lightboxSlides.push({ src, alt });
        });
      }

      function openLightbox(idx) {
        if (!lightbox || lightboxSlides.length === 0) return;
        lightboxCurrent = idx;
        showLightboxImage(lightboxCurrent);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lightbox.focus();
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.hidden = true;
        document.body.style.overflow = '';
      }

      function showLightboxImage(idx) {
        if (idx < 0) idx = lightboxSlides.length - 1;
        if (idx >= lightboxSlides.length) idx = 0;
        lightboxCurrent = idx;
        if (lightboxImg) {
          lightboxImg.style.opacity = '0';
          setTimeout(() => {
            lightboxImg.src = lightboxSlides[idx].src;
            lightboxImg.alt = lightboxSlides[idx].alt;
            lightboxImg.style.opacity = '1';
          }, 120);
        }
        if (lightboxCounter) {
          lightboxCounter.textContent = (idx + 1) + ' / ' + lightboxSlides.length;
        }
      }

      buildLightboxSlides();

      // Open on zoom button click
      root.querySelector('[data-zoom-open]')?.addEventListener('click', () => openLightbox(currentSlide));
      // Also open on main image click
      root.querySelector('.cpdp__main-track')?.addEventListener('click', (e) => {
        if (!e.target.closest('[data-gallery-prev]') && !e.target.closest('[data-gallery-next]') && !e.target.closest('[data-zoom-open]')) {
          openLightbox(currentSlide);
        }
      });

      if (lightbox) {
        lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
        lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => showLightboxImage(lightboxCurrent - 1));
        lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showLightboxImage(lightboxCurrent + 1));
        // Close on backdrop click
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox || e.target === lightbox.querySelector('[data-lightbox-stage]')) closeLightbox();
        });
        // Keyboard nav
        document.addEventListener('keydown', (e) => {
          if (lightbox.hidden) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') showLightboxImage(lightboxCurrent - 1);
          if (e.key === 'ArrowRight') showLightboxImage(lightboxCurrent + 1);
        });
      }

      /* ---------- VARIANT SELECTION ---------- */
      const optionInputs = root.querySelectorAll('[data-option-input]');
      const variantIdInput = root.querySelector('[data-variant-id]');
      const atcBtn = root.querySelector('[data-atc]');
      const colorValueEl = root.querySelector('[data-option-value]');

      function getSelectedOptions() {
        const selected = [];
        root.querySelectorAll('.cpdp__option').forEach((group, gIdx) => {
          const checked = group.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });
        return selected;
      }

      function updateVariant() {
        const selected = getSelectedOptions();
        const match = variantData.find(v => {
          return v.options.every((opt, i) => opt === selected[i]);
        });

        if (match) {
          if (variantIdInput) variantIdInput.value = match.id;
          if (atcBtn) {
            atcBtn.disabled = !match.available;
            const txtAvail = atcBtn.dataset.textAvailable || 'Add to cart';
            const txtUnavail = atcBtn.dataset.textUnavailable || 'Sold out';
            atcBtn.querySelector('span').textContent = match.available ? txtAvail : txtUnavail;
          }
          const priceEl = root.querySelector('.cpdp__price');
          if (priceEl && match.price != null) {
            priceEl.textContent = formatMoney(match.price);
          }
          const url = new URL(window.location);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      }

      function formatMoney(cents) {
        const n = cents / 100;
        return '$' + (Number.isInteger(n) ? n : n.toFixed(2));
      }

      optionInputs.forEach(input => {
        input.addEventListener('change', e => {
          const group = e.target.closest('.cpdp__option');
          group.querySelectorAll('.cpdp__pill, .cpdp__swatch').forEach(el => el.classList.remove('is-active'));
          e.target.closest('.cpdp__pill, .cpdp__swatch')?.classList.add('is-active');

          if (colorValueEl && group.querySelector('.cpdp__swatches')) {
            colorValueEl.textContent = e.target.value;
          }
          updateVariant();
        });
      });

      /* ---------- QUANTITY ---------- */
      const qtyInput = root.querySelector('[data-qty-input]');
      root.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
        const v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = v;
      });
      root.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = v;
      });

      /* ---------- BUNDLE TOGGLE ---------- */
      const bundleBtn = root.querySelector('[data-bundle-toggle]');
      const bundlePanel = root.querySelector('[data-bundle-panel]');
      if (bundleBtn && bundlePanel) {
        bundleBtn.addEventListener('click', () => {
          const open = bundleBtn.getAttribute('aria-expanded') === 'true';
          bundleBtn.setAttribute('aria-expanded', String(!open));
          bundlePanel.hidden = open;
        });
      }

      /* ---------- DISPATCH COUNTDOWN ---------- */
      const dispatchEl = root.querySelector('[data-dispatch-timer]');
      if (dispatchEl) {
        function updateDispatch() {
          const now = new Date();
          const cutoff = new Date(now);
          cutoff.setHours(15, 0, 0, 0);
          if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
          const diff = cutoff - now;
          const hours = Math.floor(diff / 3600000);
          const minutes = Math.floor((diff % 3600000) / 60000);
          dispatchEl.textContent = `${hours}h ${minutes}m`;
        }
        updateDispatch();
        setInterval(updateDispatch, 60000);
      }

      /* ---------- CROSS-SELL ADD (supports multiple buttons) ---------- */
      root.querySelectorAll('[data-cross-add]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const id = btn.dataset.variant;
          if (!id) return;
          btn.disabled = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id, quantity: 1 }] })
            });
            if (res.ok) {
              btn.querySelector('span').textContent = 'Added ✓';
              setTimeout(() => { btn.querySelector('span').textContent = 'Add'; btn.disabled = false; }, 1500);
            } else {
              btn.disabled = false;
            }
          } catch (err) {
            btn.disabled = false;
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
